//@ts-check
import { InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { createApolloClientWithCache } from './apolloClientUtils';

const defaultCache = new InMemoryCache({
  typePolicies: {
    Collection: {
      fields: {
        products: relayStylePagination(['sortKey', 'reverse']),
      },
    },
  },
});

const defaultClient = createApolloClientWithCache(defaultCache);

export default defaultClient;
